
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about__KqRnlEt3pGAItEQioyNDrkMAg8lDDav5SUEmADBfUMeta } from "/Users/horace/Projects/JiuYou/uono_web/src/pages/about.vue?macro=true";
import { default as indexwXVs7SYLosOY1Me09jRIy2dAGDMANUerTYHHv_45vzSJUMeta } from "/Users/horace/Projects/JiuYou/uono_web/src/pages/index.vue?macro=true";
import { default as _91id_93nokUTay1sg1WBg8eYNw41lOrN1gz_t4vuTlxprrQe08Meta } from "/Users/horace/Projects/JiuYou/uono_web/src/pages/game/[id].vue?macro=true";
import { default as index2C1VVgwbWhKdFfRbE8aVvxyJyOBbDdGcyBEnw3O23psMeta } from "/Users/horace/Projects/JiuYou/uono_web/src/pages/game/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/horace/Projects/JiuYou/uono_web/src/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/horace/Projects/JiuYou/uono_web/src/pages/index.vue")
  },
  {
    name: "game-id",
    path: "/game/:id()",
    component: () => import("/Users/horace/Projects/JiuYou/uono_web/src/pages/game/[id].vue")
  },
  {
    name: "game",
    path: "/game",
    component: () => import("/Users/horace/Projects/JiuYou/uono_web/src/pages/game/index.vue")
  }
]